import type { TaskFileChangeView } from '@/lib/api/generated/model';

/**
 * One row per path, carrying that path's most recent event within a group
 * (spec 095 FR-013). A file created and then modified by the same run is one
 * file the run changed, not two events to read. Order is first-seen, so the
 * list reads in the order the run touched things.
 */
export function latestPerPath(
  files: readonly TaskFileChangeView[],
): TaskFileChangeView[] {
  const byPath = new Map<string, TaskFileChangeView>();
  for (const file of files) {
    const seen = byPath.get(file.path);
    if (!seen || file.occurred_at > seen.occurred_at) {
      byPath.set(file.path, file);
    }
  }
  return [...byPath.values()];
}
